export default __webpack_public_path__ + "static/media/text-black.7eb3c429.svg";